import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  AlertController,
  NavParams,
  ToastController,
  ViewController,
} from "ionic-angular";
import { NavBarServiceProvider } from "../../../../providers/nav-bar-service/nav-bar-service";
import { PatientBenefitsService } from "../../../../providers/patient-charts/patient-benefits.service";
import { UtilityService } from "../../../../providers/utility-service/utility-service";
import { PatientBenefits } from "../models";

@Component({
  selector: "hold-benefit-popover",
  templateUrl: "hold-benefit-popover.html",
})
export class HoldBenefitPopover {
  benefitOnHoldForm: FormGroup;
  patientBenefits: PatientBenefits = null;

  constructor(
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private navParams: NavParams,
    private fb: FormBuilder,
    private utilService: UtilityService,
    private patientBenefitsService: PatientBenefitsService,
    private navBarService: NavBarServiceProvider,
    private alertCtrl: AlertController
  ) {}

  ngOnInit() {
    this.initBenefitOnHoldForm();
  }

  ionViewWillLoad() {
    if (this.navParams.get("patientBenefit")) {
      this.patientBenefits = this.navParams.get("patientBenefit");
    }
  }

  initBenefitOnHoldForm() {
    this.benefitOnHoldForm = this.fb.group({
      reasonForHold: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(3000),
        ]),
      ],
    });
  }

  onSubmit() {
    if (this.benefitOnHoldForm.valid) {
      // this.sanitizePatientBenefit();
      this.patientBenefits.reasonForHold =
        this.benefitOnHoldForm.get("reasonForHold").value;
      this.patientBenefits.readyToBill = "Hold";
      this.saveBenefitOnHold();
    }
  }

  onCancel = () => {
    this.dismissModal();
  };

  onDismiss = (res) => {
    // CO-3068 — a missing result (undefined) threw on `res.error`; treat no
    // result as a clean dismiss.
    if (!res || res.error == null) {
      this.dismissModal();
    } else {
      this.presentToast(res.error);
    }
  };

  dismissModal() {
    this.viewCtrl.dismiss({ patientBenefits: this.patientBenefits });
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }

  saveBenefitOnHold() {
    const errorMsg = "Failed to save the benefit.";
    const successMsg = "Benefit updated successfully.";

    this.utilService.increaseSpinnerCount("Saving Benefit...");
    this.patientBenefitsService
      .postPatientBenefit(
        this.navBarService.getPatientChartId(),
        this.patientBenefits
      )
      .subscribe(
        (response) => {
          if (response) {
            this.dismissModal();
            this.utilService.decreaseSpinnerCount();
            // const alert = this.alertCtrl.create({
            //   enableBackdropDismiss: false,
            //   title: 'Success Message',
            //   message: successMsg,
            //   buttons: [
            //     {
            //       text: 'OK',
            //       handler: () => {
            //         this.benefitOnHoldForm.reset();
            //       },
            //     },
            //   ],
            // });
            // alert.present();
          } else {
            this.utilService.decreaseSpinnerCount();
            this.onFailure(errorMsg);
          }
        },
        (_err) => {
          this.utilService.decreaseSpinnerCount();
          this.onFailure(errorMsg);
        }
      );
  }

  // sanitizePatientBenefit() {
  //   if (
  //     this.patientBenefits.activePrimaryBenefitsId &&
  //     this.patientBenefits.activePrimaryBenefitsId === '-'
  //   ) {
  //     this.patientBenefits.activePrimaryBenefitsId = null;
  //   }
  //   this.patientBenefits.effectiveDate = this.formatDate(
  //     this.patientBenefits.effectiveDate
  //   );

  //   if (this.patientBenefits.expiredDate && this.patientBenefits.expiredDate === 'Invalid date') {
  //     this.patientBenefits.expiredDate = null;
  //   }

  //   if (this.patientBenefits.expiredDate && this.patientBenefits.expiredDate !== '-') {
  //     this.patientBenefits.expiredDate = this.formatDate(
  //       this.patientBenefits.expiredDate
  //     );
  //   }

  //   if (
  //     this.patientBenefits.subscriber &&
  //     this.patientBenefits.subscriber.dateOfBirth
  //   ) {
  //     this.patientBenefits.subscriber.dateOfBirth = this.formatDate(
  //       this.patientBenefits.subscriber.dateOfBirth
  //     );
  //   }
  // }

  // formatDate(date) {
  //   if (date !== null && date != '') {
  //     return moment(date).format('YYYY-MM-DD');
  //   } else {
  //     return '';
  //   }
  // }

  onFailure(msg: string) {
    this.utilService.decreaseSpinnerCount();
    const alert = this.alertCtrl.create({
      title: "Error Message",
      message: msg,
      buttons: [{ text: "Cancel" }],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-benefits/hold-benefit-popover/hold-benefit-popover.ts